import { Gear } from "phosphor-react-sc"
import { stopPropagation } from "../../../../../helpers/ObjectHelpers";
import MapPropertiesService from "../../../services/MapPropertiesService";
import { useSetPanelState } from "../../../hooks/useMapStore";

interface MapControlSettingsProps {
    show?: boolean,
}
export const MapControlSettings = ({
    show = false,
}: MapControlSettingsProps) => {

    const setPanelState = useSetPanelState();

    const panelStates = MapPropertiesService.panelStates;
    

    return (
        show &&
        <div className="google-map-control google-map-control-button" onClick={onClick}>
            <Gear size={20} weight="duotone" />
        </div>
    )

    function onClick(e: any) {
        stopPropagation(e);
        setPanelState(panelStates.Settings);
    }
}
